// État global + fonction partagée d'ouverture du popup store locator.
// Source unique utilisée par product-form, les drawers d'options (product-option-info)
// et la section RDV (ax-store-rdv) afin d'éviter toute divergence d'implémentation.
window.storeLocatorState = window.storeLocatorState || {
	alreadyFetch: false,
	isOpen: false,
	isFetching: false
};

if (!window.openProductStoreLocator) {
	window.openProductStoreLocator = function (filter) {
		const storeLocContent = document.querySelector('#ax-popup-storeloc');
		if (!storeLocContent) return;

		// Listener de fermeture attaché une seule fois
		if (!window.storeLocatorState.initialized) {
			storeLocContent.querySelector('.modal-close')?.addEventListener('click', () => {
				storeLocContent.style.display = 'none';
				window.storeLocatorState.isOpen = false;
			});
			window.storeLocatorState.initialized = true;
		}

		// Déjà fetché : on ré-affiche simplement (pas de réinjection de scripts)
		if (window.storeLocatorState.alreadyFetch) {
			storeLocContent.style.display = 'block';
			window.storeLocatorState.isOpen = true;
			return;
		}

		// Lock partagé : évite des fetch parallèles (double-clic / clics multiples)
		// qui injecteraient les scripts en double.
		if (window.storeLocatorState.isFetching) return;
		window.storeLocatorState.isFetching = true;

		fetch('/pages/magasins?sections=store-locator')
			.then((response) => response.json())
			.then((data) => {
				const html = new DOMParser().parseFromString(data['store-locator'], 'text/html');
				const scripts = html.getElementsByTagName('script');
				window.axStoreLocFetch = true;
				window.axStoreLocFilter = filter;
				window.productFetch = true;

				for (let i = 0; i < scripts.length; i++) {
					const script = document.createElement('script');
					scripts[i].textContent !== '' ? (script.textContent = scripts[i].textContent) : (script.src = scripts[i].src);
					document.getElementsByTagName('head')[0].appendChild(script);
				}

				storeLocContent.insertAdjacentHTML('beforeend', html.body.innerHTML);

				const updated = document.querySelector('#ax-popup-storeloc');
				const activeFilter = updated.querySelector('[data-store-filter="' + filter + '"]');
				if (activeFilter) activeFilter.classList.add('active');

				updated.style.display = 'block';
				window.storeLocatorState.alreadyFetch = true;
				window.storeLocatorState.isOpen = true;
			})
			.catch((error) => console.error(error))
			.finally(() => {
				window.storeLocatorState.isFetching = false;
			});
	};
}

if (!customElements.get('product-form')) {
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.attachListeners()
		}

		attachListeners() {
			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
			this.storeLocButton = this.querySelector('[data-store-button]');
			this.submitButton = this.querySelector('[type="submit"]');
			if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
			this.init()
		}

		init() {
			this.storeLocButton?.addEventListener('click', () => {
				window.openProductStoreLocator(this.storeLocButton.dataset.storeButton);
			});
		}


		onSubmitHandler(evt) {
			evt.preventDefault();
			if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

			this.handleErrorMessage();

			this.submitButton.setAttribute('aria-disabled', true);
			this.submitButton.classList.add('loading');
			this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			const formData = new FormData(this.form);
			if (this.cart) {
				formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
				formData.append('sections_url', window.location.pathname);
				this.cart.setActiveElement(document.activeElement);
			}
			config.body = formData;


			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						this.handleErrorMessage(response.description);

						const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
						if (!soldOutMessage) return;
						this.submitButton.setAttribute('aria-disabled', true);
						this.submitButton.querySelector('span').classList.add('hidden');
						soldOutMessage.classList.remove('hidden');
						this.error = true;
						return;
					} else if (!this.cart) {
						window.location = window.routes.cart_url;
						return;
					}

					this.error = false;
					const quickAddModal = this.closest('quick-add-modal');
					if (quickAddModal) {
						document.body.addEventListener('modalClosed', () => {
							setTimeout(() => {
								this.cart.renderContents(response)
							});
						}, {once: true});
						quickAddModal.hide(true);
					} else {
						this.cart.renderContents(response);
					}
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					this.submitButton.classList.remove('loading');
					if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
					if (!this.error) this.submitButton.removeAttribute('aria-disabled');
					this.querySelector('.loading-overlay__spinner').classList.add('hidden');
				});
		}

		handleErrorMessage(errorMessage = false) {
			this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
			if (!this.errorMessageWrapper) return;
			this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

			this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

			if (errorMessage) {
				this.errorMessage.textContent = errorMessage;
			}
		}
	});
}
